module.exports = __webpack_public_path__ + "img/1.075cd36b.png";